'use strict'
import axios from '@/global/axios.js'
import * as action from '@/actions/authorizedLoginIp'

// 授权登录IP列表
export const AUTHORIZED_LOGIN_IP_LIST = (pageNum, pageSize) => {
  return axios({
    url: action.AUTHORIZED_LOGIN_IP_LIST,
    method: 'POST',
    data: { pageNum, pageSize }
  })
}
// 添加登录授权IP
export const AUTHORIZED_LOGIN_IP_SUBMIT = (ips) => {
  return axios({
    url: action.AUTHORIZED_LOGIN_IP_SUBMIT,
    method: 'POST',
    data: { ips }
  })
}
// 删除登录授权IP
export const AUTHORIZED_LOGIN_IP_DELETE = id => {
  return axios({
    url: action.AUTHORIZED_LOGIN_IP_DELETE,
    method: 'POST',
    data: { id }
  })
}
// 查看本地IP
export const AUTHORIZED_LOGIN_IP_LOCAL = () => {
  return axios({
    url: action.AUTHORIZED_LOGIN_IP_LOCAL,
    method: 'POST',
    data: { }
  })
}



// WEBPACK FOOTER //
// ./src/api/authorizedLoginIp.js